import { z } from 'zod';
import { contractStatusEnumSchema } from '@shared/enums/contract-status.enum';

export const contractListDataSchema = z.object({
  id: z.string(),
  status: contractStatusEnumSchema,
  name: z.string(),
  createdAt: z.string().nullable(),
  procedureContracts: z
    .object({
      procedure: z.object({
        id: z.string(),
        name: z.string(),
      }),
    })
    .array(),
  productContracts: z
    .object({
      product: z.object({
        id: z.string(),
        displayName: z.string(),
      }),
    })
    .array(),
});

export type ContractListData = z.infer<typeof contractListDataSchema>;
